import { useMemo } from 'react';

import { useLocalState } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Details/useLocalState';
import { useSelector } from 'react-redux';
import { kRDrawerSecondaryPanelSelector } from 'selectors/krSecondaryPanel';

const userParentOKRSelection = () => {
  const { details } = useSelector(kRDrawerSecondaryPanelSelector);

  const { okrTimePeriod, parentUuid, parentText, parentType, parentVisibilityType } = details;

  const [localSelectedTimePeriod, setLocalSelectedTimePeriod] = useLocalState(okrTimePeriod);

  const parentPost = useMemo(
    () => ({
      uuid: parentUuid
        ? String(parentUuid)
        : null /* At some place we are reading uuid as number and that causes issues in comparison */,
      text: parentText,
      type: parentType,
      visibilityType: parentVisibilityType,
    }),
    [parentUuid, parentText, parentType, parentVisibilityType]
  );

  const [selectedParent, setSelectedParent] = useLocalState(parentPost);

  return {
    localSelectedTimePeriod,
    setLocalSelectedTimePeriod,
    selectedParent,
    setSelectedParent,
  };
};

export { userParentOKRSelection };
